import { Component, ComponentFactoryResolver, EventEmitter, Input, Output, Type, ViewChild } from '@angular/core';
import { UserSettingsBase } from '../../models';
import { SettingsDirective } from '../../directives';

@Component({
  selector: 'app-user-settings-tab-container',
  templateUrl: './user-settings-tab-container.component.html',
  styleUrls: ['./user-settings-tab-container.component.scss'],
  standalone: true,
  imports: [SettingsDirective]
})
export class UserSettingsTabContainerComponent {
  @Input() item?: Type<any>;
  @Output() isDirtyChanged = new EventEmitter<boolean>();
  component?: UserSettingsBase;

  @ViewChild(SettingsDirective, { static: true }) settingsHost?: SettingsDirective;
  constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit(): void {
    this.loadComponent();
  }

  get isDirty(): boolean {
    return this.component?.isDirty ?? false;
  }

  loadComponent() {
    if (this.item == undefined || this.settingsHost == undefined) {
      return;
    }

    const viewContainerRef = this.settingsHost.viewContainerRef;
    viewContainerRef.clear();

    let factory = this.componentFactoryResolver.resolveComponentFactory(this.item);
    const componentRef = viewContainerRef.createComponent<UserSettingsBase>(factory);
    this.component = componentRef.instance;

    componentRef.instance.isDirtyChanged.subscribe(() => {
      this.isDirtyChanged.emit(this.isDirty);
    });

    //componentRef.instance.data = adItem.data;
  }

  save() {
    if (this.isDirty) {
      this.component?.save();
    }
  }
}
